export default {
  labels: {
    in_store_card_payments_not_supported: '⚠️ Doar numerar la restaurant. Plata cu cardul nu este acceptată.',
  },
};
